import {ref, reactive, computed, DefineComponent} from "vue";
import {defineStore} from "pinia";

import Layout from "@/layouts/DefaultLayout.vue";
import LoaderLayout from "@/layouts/LoaderLayout.vue";
import EmptyLayout from "@/layouts/EmptyLayout.vue";

export const useLayoutsStore = defineStore('layouts', () => {
    // Типы шаблонов
    const layoutTypes = reactive({
        layout: 'layout',
        loader: 'loader',
        empty: 'empty'
    });

    // Шаблоны компонентов для каждого типа
    const layouts = reactive<{ [key: string]: DefineComponent }>(<{ [key: string]: DefineComponent }>{
        [layoutTypes.layout]: Layout,
        [layoutTypes.loader]: LoaderLayout,
        [layoutTypes.empty]: EmptyLayout,
    })

    // Текущий шаблон (по умолчанию - загрузчик)
    const layout = ref<string>('loader');

    // Вычисляемый шаблон для отображения в компоненте
    const switchLayout = computed(() => {
        return layouts[layout.value];
    });

    // Метод для изменения текущего шаблона
    const changeLayout = (name: string) => {
        layout.value = name;
    };

    return {
        layoutTypes,
        layouts,
        layout,
        switchLayout,
        changeLayout,
    };
});